import React, { FunctionComponent, useContext } from 'react';
import { Trans } from 'react-i18next';
import './AboutCharity.scss';
import PageList from '../PageList/PageList';
import AboutRelationship from '../AboutRelationship/AboutRelationship';
import CharityRegNumber from '../CharityRegNumber/CharityRegNumber';
import { ColorsContext } from '../../context/ColorsContext';
import CharitySocialLinks from '../CharitySocialLinks/CharitySocialLinks';

interface AboutCharityProps {
  charities: {
    id?: string;
    url?: string;
    logo: string;
    name?: string | null;
    profilePageUrl: string;
    description?: string | null;
    registrationNumber?: string | null;
  }[];
  socialLinks?: {
    url?: string | null;
    type?: string | null;
  }[];
}

const AboutCharity: FunctionComponent<AboutCharityProps> = ({
  charities,
  socialLinks,
}) => {
  const textColor = useContext(ColorsContext)?.foregroundColor;

  if (charities.length > 1) {
    return (
      <>
        <PageList
          pages={charities.map(x => ({
            charityId: x.id,
            url: x.profilePageUrl,
            logo: x.logo,
          }))}
        />
        <FindOutMoreLink />
      </>
    );
  }

  if (charities.length === 1) {
    const charity = charities[0];

    return (
      <>
        <AboutRelationship
          logo={charity.logo}
          name={charity.name || ''}
          landingPageUrl={charity.profilePageUrl}
          description={charity.description}
          logoVariant="normal"
        >
          <CharityRegNumber className="jg-space-mbn" />
          {charity.url && (
            <p itemProp="url" className="jg-text--small-light jg-space-mbn">
              {charity.url}
            </p>
          )}
        </AboutRelationship>
        <FindOutMoreLink textColor={textColor} />
        {socialLinks && <CharitySocialLinks socialLinks={socialLinks} />}
      </>
    );
  }

  return null;
};

interface FindOutMoreLinkProps {
  textColor?: string;
}

const FindOutMoreLink: FunctionComponent<FindOutMoreLinkProps> = ({
  textColor,
}) => (
  <a
    href="/fundraising"
    target="_blank"
    className="jg-about-charity__link jg-space-mtsm"
    style={{ color: textColor }}
  >
    <Trans i18nKey="charity.findOutMore">
      Find out more about charity fundraising
    </Trans>
  </a>
);

export default AboutCharity;
